import { createEntityMutation } from '../../createEntityMutation';
import {
  ConvertibleService,
  type Wealthlane_CapTable_Dtos_Convertible_UpdateConvertibleDto,
  type Wealthlane_CapTable_Enums_ConvertibleInstrumentType,
} from '@wealthlane/api-services/wealthlane-captable-service';

/** Required until @wealthlane/api-services is regenerated from updated cap-table swagger. */
export type UpdateConvertibleDto = Wealthlane_CapTable_Dtos_Convertible_UpdateConvertibleDto & {
  participantId: string;
  instrumentType: Wealthlane_CapTable_Enums_ConvertibleInstrumentType;
};

export type UpdateConvertibleVariables = {
  id: string;
  payload: UpdateConvertibleDto;
};

export const usePutConvertible = createEntityMutation<unknown, UpdateConvertibleVariables>({
  mutationFn: ({ id, payload }) => ConvertibleService.putApiCapTableApiAppConvertible(id, payload),
  invalidateKeys: ['dt-v2-page', 'getConvertible'],
});
